import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Button Icon Style 01 - Touch App (Material Symbol)
 * Buttons are always shown as "active" (blue) - they don't have ON/OFF state
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:touch_app
 */
export const Style01_TouchApp: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-blue-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      touch_app
    </span>
  );
};

export default Style01_TouchApp;
